import ClientCURModule from "@/modules/ClientCUR";

function ViewClientPage() {
  return <ClientCURModule type="view" />;
}

export default ViewClientPage;
